import m from 'mithril'

import icon from './360.png'

class ControlIndicator {
  onbeforeremove(vnode) {
    vnode.dom.classList.add('is-exiting')
    return new Promise(resolve => {
      vnode.dom.addEventListener('animationend', resolve)
    })
  }

  view(vnode) {
    return (
      <div className={`control-indicator`}>
        <div className="control-indicator-icon">
          <img src={icon} />
        </div>
        <p className="control-indicator-text">Click og træk for at dreje, click på pile for at bevæge dig.</p>
      </div>
    )
  }
}

export default ControlIndicator
